export default __webpack_public_path__ + "static/media/Algo-Toolbox.a5815657.png";